export default __webpack_public_path__ + "static/media/icon-preview.9ac6a620.svg";